<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";




export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader



  },
  data() {

    return {
      title: "Página em Contrução",
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Página em Contrução",
          active: true
        }
      ],
    };
  },
  created() {

  },
  mounted() {

  },



  methods: {


  },

};

</script>



<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">


    </div>





  </Layout>
</template>

